import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Login } from 'src/app/models/Login';
import { ApiService } from '../shared/api.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private api: ApiService,
  ) { }

  public login(data: Login): Observable<any> {
    return this.api.post(`/oauth/token`, data, `developer`);
  }

  public adminLogin(data: Login): Observable<any> {
    return this.api.post(`/api/login`, data, `developer`);
  }

  public getCurrentUser(): Observable<any> {
    return this.api.get(`/api/v1/user/current`, 'developer');
  }
}
